import React, { useState, useEffect } from 'react';
import { Document, Page, Text, View, Image } from '@react-pdf/renderer';
import styles from '../constant/style';

const PDFDocument = ({ formData, referenceNumber }) => {
    const [qrCodeUrl, setQrCodeUrl] = useState('');

    useEffect(() => {
        // Générer une URL pour le QR code en utilisant un service externe
        const qrData = JSON.stringify({
            reference: referenceNumber,
            type: formData.type_voyage,
            document: formData.document_voyage.type,
            numero: formData.document_voyage.numero
        });

        // Utiliser un service de QR code gratuit pour générer l'image
        const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=${encodeURIComponent(qrData)}`;
        setQrCodeUrl(qrUrl);
    }, [referenceNumber, formData]);

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                {/* En-tête gouvernemental */}
                <View style={styles.governmentHeader}>
                    <Text style={styles.governmentTitle}>République du Niger</Text>
                    <Text style={styles.ministryTitle}>Ministère de l'Intérieur, de la Sécurité Publique et de l'Administration du Territoire</Text>
                </View>

                {/* En-tête Niger Voyage */}
                <View style={styles.header}>
                    <View style={styles.headerLeft}>
                        <Text style={styles.headerTitle}>NIGER VOYAGE</Text>
                        <Text style={styles.subTitle}>Agence de Formalités de Voyage</Text>
                    </View>
                    <View style={styles.reference}>
                        <Text style={styles.referenceText}>{referenceNumber}</Text>
                        <Text style={{ fontSize: 8, color: '#666' }}>
                            {new Date().toLocaleDateString()}
                        </Text>
                    </View>
                </View>

                {/* Contenu */}
                <View style={styles.contentContainer}>
                    {/* Document d'identité */}
                    <View style={styles.section}>
                        <Text style={styles.sectionTitle}>DOCUMENT D'IDENTITÉ</Text>
                        <View style={styles.row}>
                            <Text style={styles.label}>Type:</Text>
                            <Text style={styles.value}>{formData.document_voyage.type}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Numéro:</Text>
                            <Text style={styles.value}>{formData.document_voyage.numero}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Expire le:</Text>
                            <Text style={styles.value}>{formData.document_voyage.date_expiration}</Text>
                        </View>
                    </View>

                    {/* Transport */}
                    <View style={styles.section}>
                        <Text style={styles.sectionTitle}>TRANSPORT</Text>
                        {formData.type_voyage === 'aerien' ? (
                            <>
                                <View style={styles.row}>
                                    <Text style={styles.label}>Compagnie:</Text>
                                    <Text style={styles.value}>{formData.sejour.compagnie_aerienne}</Text>
                                </View>
                                <View style={styles.row}>
                                    <Text style={styles.label}>Vol:</Text>
                                    <Text style={styles.value}>{`${formData.sejour.date_vol} ${formData.sejour.heure_vol}`}</Text>
                                </View>
                                <View style={styles.row}>
                                    <Text style={styles.label}>Départ:</Text>
                                    <Text style={styles.value}>{formData.sejour.aeroport_depart}</Text>
                                </View>
                                <View style={styles.row}>
                                    <Text style={styles.label}>Arrivée:</Text>
                                    <Text style={styles.value}>{formData.sejour.aeroport_arrivee}</Text>
                                </View>
                            </>
                        ) : (
                            <>
                                <View style={styles.row}>
                                    <Text style={styles.label}>Compagnie:</Text>
                                    <Text style={styles.value}>{formData.sejour.compagnie_terrestre}</Text>
                                </View>
                                <View style={styles.row}>
                                    <Text style={styles.label}>Véhicule:</Text>
                                    <Text style={styles.value}>{`${formData.sejour.type_vehicule} - ${formData.sejour.numero_vehicule}`}</Text>
                                </View>
                                <View style={styles.row}>
                                    <Text style={styles.label}>Départ:</Text>
                                    <Text style={styles.value}>{`${formData.sejour.ville_depart} - ${formData.sejour.date_depart} ${formData.sejour.heure_depart}`}</Text>
                                </View>
                                <View style={styles.row}>
                                    <Text style={styles.label}>Arrivée:</Text>
                                    <Text style={styles.value}>{formData.sejour.ville_arrivee}</Text>
                                </View>
                            </>
                        )}
                    </View>

                    {/* Séjour */}
                    <View style={styles.section}>
                        <Text style={styles.sectionTitle}>SÉJOUR</Text>
                        <View style={styles.row}>
                            <Text style={styles.label}>Motif:</Text>
                            <Text style={styles.value}>{formData.sejour.motif}</Text>
                        </View>
                        {formData.sejour.motif === 'Autre' && (
                            <View style={styles.row}>
                                <Text style={styles.label}>Autre Motif:</Text>
                                <Text style={styles.value}>{formData.sejour.autre_motif}</Text>
                            </View>
                        )}
                        <View style={styles.row}>
                            <Text style={styles.label}>Durée:</Text>
                            <Text style={styles.value}>{formData.sejour.duree} Jours</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Destination:</Text>
                            <Text style={styles.value}>{formData.sejour.ville_arrivee}</Text>
                        </View>
                    </View>

                    {/* Contact d'urgence */}
                    <View style={styles.section}>
                        <Text style={styles.sectionTitle}>CONTACT D'URGENCE</Text>
                        <View style={styles.row}>
                            <Text style={styles.label}>Nom:</Text>
                            <Text style={styles.value}>{`${formData.contact_urgence.nom} ${formData.contact_urgence.prenom}`}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Téléphone:</Text>
                            <Text style={styles.value}>{formData.contact_urgence.telephone}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Email:</Text>
                            <Text style={styles.value}>{formData.contact_urgence.email}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.label}>Lien:</Text>
                            <Text style={styles.value}>{formData.contact_urgence.lien}</Text>
                        </View>
                        {formData.contact_urgence.lien === 'Autre' && (
                            <View style={styles.row}>
                                <Text style={styles.label}>Autre Lien:</Text>
                                <Text style={styles.value}>{formData.contact_urgence.autre_lien}</Text>
                            </View>
                        )}
                    </View>
                </View>

                {/* QR Code */}
                <View style={styles.qrSection}>
                    {qrCodeUrl && (
                        <Image
                            src={qrCodeUrl}
                            style={styles.qrCode}
                        />
                    )}
                    <Text style={styles.qrText}>
                        {referenceNumber}
                    </Text>
                </View>

                {/* Footer */}
                <Text style={styles.footer}>
                    Niger Voyage - Agence de Formalités de Voyage{'\n'}
                    Tel: +227 XX XX XX XX - Email: contact@nigervoyage.ne
                </Text>
            </Page>
        </Document>
    );
};

export default PDFDocument;